import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ManagementTabsService {
  private _error = new BehaviorSubject<string>('');

  constructor() {}

  get error$() {
    return this._error.asObservable();
  }
  get error() {
    return this._error.value;
  }

  set error(value) {
    this._error.next(value);
  }
}
